import { render } from "./CompanyInfo.vue?vue&type=template&id=e63c50d0&scoped=true&ts=true"
import script from "./CompanyInfo.vue?vue&type=script&lang=ts"
export * from "./CompanyInfo.vue?vue&type=script&lang=ts"

import "./CompanyInfo.vue?vue&type=style&index=0&id=e63c50d0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e63c50d0"]])

export default __exports__